import { render, staticRenderFns } from "./AssetManagement.vue?vue&type=template&id=120dad0e&scoped=true"
import script from "./AssetManagement.vue?vue&type=script&lang=js"
export * from "./AssetManagement.vue?vue&type=script&lang=js"
import style0 from "./AssetManagement.vue?vue&type=style&index=0&id=120dad0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120dad0e",
  null
  
)

export default component.exports